// extracted by mini-css-extract-plugin
export default {"aimsCard":"AptechAimsCard_aimsCard__oajB2","aimTextStyle":"AptechAimsCard_aimTextStyle__M7Z1R"};